import { Form, Formik } from 'formik';
import { FC } from 'react';

import { ResendPasswordFormValidation } from '@/authentication/templates/AuthFormLegacy/Forms/Forms.types';
import { CheckoutDescription } from '@/checkout/components/CheckoutDescription/CheckoutDescription';
import { MICROCOPY } from '@/data/microcopy/microcopyDictionary';
import { Button } from '@/general/components/Button/Button';
import { getMicrocopy } from '@/stores/microcopyStore';
import { encodeHTMLEntities } from '@/utils/encodeHTMLEntities';

import styles from './PersonalizedQuoteForm.module.scss';
import { PersonalizedQuoteFormProps, ResendPasswordFormValues } from './PersonalizedQuoteForm.type';

const initialValues: ResendPasswordFormValues = {};

export const ResendPasswordForm: FC<PersonalizedQuoteFormProps<ResendPasswordFormValues> & { email: string }> = ({
  email,
  onSubmit,
  values,
  onBack,
}) => (
  <>
    <div className={styles.checkoutDescription}>
      <CheckoutDescription
        title={getMicrocopy(MICROCOPY.AUTHENTICATION_RESEND_PASSWORD_FORM_TITLE)}
        description={getMicrocopy(MICROCOPY.AUTHENTICATION_RESEND_PASSWORD_FORM_CAPTION, true, {
          email: encodeHTMLEntities(email),
        })}
        onBack={onBack}
      />
    </div>
    <div className={styles.resendPasswordForm}>
      <Formik
        initialValues={{ ...initialValues, ...values }}
        validateOnChange={false}
        onSubmit={onSubmit}
        validationSchema={ResendPasswordFormValidation}
      >
        {(props) => (
          <Form className={styles.form}>
            <footer className={styles.footer}>
              <Button type="submit" isLoading={props.isSubmitting} fullWidth data-testid="submit">
                {getMicrocopy(MICROCOPY.PERSONALIZED_QUOTE_RESEND_PASSWORD_CTA)}
              </Button>
            </footer>
          </Form>
        )}
      </Formik>
    </div>
  </>
);
